<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Simple",
  props: {

  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
</style>
